// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"413e075a","627":"223650ad","653":"12b9f112","738":"ae165552","923":"57ca2ff0"}[chunkId] + ".chunk.js";
};